import Vue from "vue";

import WebsocketConnection from "../../websocket/websocket_connection";
import EventBus from "@/event/event-bus";

let pendingEvents = [];
let latestCliVersion = null;

function pushPendingEvent(eventName, payload, pendedEventCreateTime) {
  pendingEvents.push({
    name: eventName,
    payload: payload,
    time: pendedEventCreateTime ? pendedEventCreateTime : Date.now()
  });
}

function getNextWsPendingEvent(events) {
  if (!events.length) {
    return null;
  }
  var event = events.shift();
  if (Date.now() - event.time > 5000) {
    return getNextWsPendingEvent(events);
  }

  return event;
}

function triggerPendingEvents(context) {
  //Make copy of current pending events list
  let events = pendingEvents.slice();
  //Clear original pending events list
  pendingEvents = [];
  //Try to handle all pending events
  var nextEvent = getNextWsPendingEvent(events);
  while (nextEvent) {
    handlePrinterWebsocketEvent(context, nextEvent.name, nextEvent.payload, nextEvent.time);
    nextEvent = getNextWsPendingEvent(events);
  }
  //Check for new pending events, there are cases when handlers can generate new pending events
  if (pendingEvents.length > 0) {
    setTimeout(() => triggerPendingEvents(context), 500);
  }
}

function createHostFromPrinter(printer) {
  return {
    host_id: printer.host_id,
    cli_build: printer.cli_build,
    cli_ver: printer.cli_ver,
    host_color: printer.host_color,
    host_name: printer.host_name,
    host_num: printer.host_num,
    local_ip: printer.local_ip,
    platform: printer.platform
  }
}

function updatePrintersAndJobs(context, data) {
  if (data.result) {
    let prepend = context.state.printers.length > 0;
    if (data.message.print_settings) {
      context.commit('SET_PRINT_SETTINGS', data.message.print_settings);
    }
    if (data.message.disconnected_printers) {
      context.commit('SET_DISCONNECTED_PRINTERS', data.message.disconnected_printers);
    }
    if (data.message.printers) {
      for (let i in data.message.printers) {
        const printer = data.message.printers[i];
        const printerIndex = context.getters.getPrinterIndex(printer.printer_id);
        if (printerIndex >= 0) {
          updatePrinterData(context, printerIndex, printer);
        } else {
          context.commit('ADD_PRINTER', {printer, prepend});
          if (printer.active === 't') {
            const hostIndex = context.getters.getHostIndex(printer.host_id);
            if (hostIndex < 0) {
              //Add new host
              context.commit('ADD_HOST', {host: createHostFromPrinter(printer), prepend});
            }
          }
        }
      }
    }
    if (data.message.jobs) {
        for (let i in data.message.jobs) {
          const job = data.message.jobs[i];
        if (data.message.jobs.length === 1) {
          console.log(job, i);
        }
          const jobIndex = context.getters.getJobIndex(job.job_id);
          if (jobIndex >= 0) {
            context.commit('UPDATE_JOB', {job, jobIndex});
          } else {
            context.commit('ADD_JOB', job);
        }
      }
    }
  }
}

function updatePrinterData(context, printerIndex, printer) {
  const isChangeActiveState = printer.active !== undefined &&
    context.state.printers[printerIndex].active !== printer.active;
  context.commit('UPDATE_PRINTER', {printer, printerIndex});
  if (isChangeActiveState) {
    const hostIndex = context.getters.getHostIndex(printer.host_id);
    if (printer.active === 't'  && hostIndex < 0) {
      //Add new host
      context.commit('ADD_HOST', {host: createHostFromPrinter(printer)});
    } else if (printer.active === 'f' && hostIndex >= 0) {
      //Check printers in the same host
      let hasAnotherPrinter = false;
      for (let i in context.state.printers) {
        if (context.state.printers[i].active === 't' &&
          context.state.printers[i].printer_id !== printer.printer_id &&
          context.state.printers[i].host_id === printer.host_id) {
          hasAnotherPrinter = true;
          break;
        }
      }
      if (!hasAnotherPrinter) {
        //Remove host
        context.commit('REMOVE_HOST', hostIndex);
      }
    }
  }
}

const websocketPrinterEvents = [
  'printer:add',
  'printer:update',
  'printer:delete',
  'printer:share',
  'printer:unshare',
  'printer:job_log',
  'printer:job_add',
  'printer:job_update',
  'printer:job_delete',
  'printer:host_update'
];

const PRINTER_LOG_NO_SPACE = 'There is not enough space available on the disk to start the print';

function handlePrinterWebsocketEvent(context, eventName, event, pendedEventCreateTime) {
  // console.log(eventName, event);
  switch (eventName) {
    case 'printer:add':
    case 'printer:share': {
      let printerId = null;
      if (event instanceof Array) {
        var printers = [];
        for (let i in event) {
          printers.push(event[i].printer_id);
        }
        printerId = printers;
      } else {
        printerId = event.printer_id;
      }
      context.dispatch('fetchPrinterData', printerId);
    }
    break;

    case 'printer:update': {
      const printerIndex = context.getters.getPrinterIndex(event.printer_id);
      if (printerIndex >= 0) {
        const printer = Object.assign({}, context.state.printers[printerIndex], event);
        updatePrinterData(context, printerIndex, printer);
      } else {
        pushPendingEvent(eventName, event, pendedEventCreateTime);
      }
    }
    break;

    case 'printer:delete':
    case 'printer:unshare': {
      if (!(event instanceof Array)) {
        event = [event];
      }
      for (let i in event) {
        const printerIndex = context.getters.getPrinterIndex(event[i].printer_id);
        if (printerIndex >= 0) {
          context.commit('REMOVE_PRINTER', printerIndex);
        } else {
          pushPendingEvent(eventName, event[i], pendedEventCreateTime);
        }
      }
    }
    break;

    case 'printer:job_add':
      context.dispatch('refreshJobData', {printerId: event.printer_id, jobId: event.job_id});
    break;

    case 'printer:job_update': {
      const jobIndex = context.getters.getJobIndex(event.job_id);
      if (jobIndex >= 0) {
        if (event.status_id !== undefined) {
          event.job_status_id = event.status_id;
        }
        const job = Object.assign({}, context.state.jobs[jobIndex], event);
        context.commit('UPDATE_JOB', {job, jobIndex});
      } else {
        pushPendingEvent(eventName, event, pendedEventCreateTime);
      }
    }
    break;

    case 'printer:job_delete': {
      const jobIndex = context.getters.getJobIndex(event.job_id);
      if (jobIndex >= 0) {
        context.commit('REMOVE_JOB', jobIndex);
      }
    }
    break;

    case 'printer:host_update': {
      if (!(event instanceof Array)) {
        event = [event];
      }
      for (let i in event) {
        let eventObj = event[i];
        const hostIndex = context.getters.getHostIndex(eventObj.host_id);
        if (hostIndex >= 0) {
          if (eventObj.printer_id) {
            delete eventObj.printer_id;
          }
          const host = Object.assign({}, context.state.hosts[hostIndex], eventObj);
          context.commit('UPDATE_HOST', {host, hostIndex});
        } else {
          pushPendingEvent(eventName, eventObj, pendedEventCreateTime);
        }
      }
    }
    break;

    case 'printer:job_log': {
      //Check log of no space available on printer
      const lastLog = event.last_log ? event.last_log.trim() : '';
      if (lastLog === PRINTER_LOG_NO_SPACE) {
        EventBus.$emit('printer_log:no_space', {printerId: event.printer_id, jobId: event.job_id});
      } else {
        // EventBus.$emit(eventName, event);
      }
    }
    break;
  }
}

const websocketDIsconnectedPrinterEvents = [
  'dprinter:add',
  'dprinter:delete'
];

function handleDisconnectedPrinterWebsocketEvent(context, eventName, event) {
  // console.log(eventName, event);
  switch (eventName) {
    case 'dprinter:add': {
      for (var i in event) {
        context.commit('ADD_DISCONNECTED_PRINTER', event[i]);
      }
    }
    break;
    case 'dprinter:delete': {
      const dPrinterIndex = context.getters.getDisconnectedPrinterIndex(event.id);
      if (dPrinterIndex >= 0) {
        context.commit('DELETE_DISCONNECTED_PRINTER', dPrinterIndex);
      }
    }
    break;
  }
}

export default {
  state: {
    printingStates: ['printing', 'downloading', 'heating', 'paused', 'cancelling_print', 'printing_locally'],
    printersWebsocketConnect: false,
    dPrintersWebsocketConnect: false,
    printSettings: {},
    hosts: [],
    printersLoaded: false,
    printers: [],
    dPrinters: [],
    jobs: []
  },
  mutations: {
    SET_HOSTS(state, hosts) {
      state.hosts = hosts;
    },
    ADD_HOST(state, {host, prepend = true}) {
      //Calculate host name if empty
      if (!host.host_name) {
        host.host_name_calculated = 'Computer ' + (state.hosts.length + 1);
      }
      prepend ? state.hosts.unshift(host) : state.hosts.push(host);
    },
    UPDATE_HOST(state, {host, hostIndex}) {
      Vue.set(state.hosts, hostIndex, host);
    },
    REMOVE_HOST(state, hostIndex) {
      Vue.delete(state.hosts, hostIndex);
      //Recalculate hosts name after deleted one
      if (state.hosts.length > (hostIndex + 1)) {
        for (let i = hostIndex + 1; i < state.hosts.length; i++) {
          if (!state.hosts[i].host_name) {
            Vue.set(state.hosts, i, Object.assign({}, state.hosts[i], {host_name_calculated: 'Computer ' + (i + 1)}));
          }
        }
      }
    },
    SET_PRINTERS(state, printers) {
      state.printers = printers;
    },
    ADD_PRINTER(state, {printer, prepend = true}) {
      printer.printer_id = (+printer.printer_id)||null;
      prepend ? state.printers.unshift(printer) : state.printers.push(printer);
    },
    UPDATE_PRINTER(state, {printer, printerIndex}) {
      printer.printer_id = (+printer.printer_id)||null;
      Vue.set(state.printers, printerIndex, printer);
    },
    REMOVE_PRINTER(state, printerIndex) {
      Vue.delete(state.printers, printerIndex);
    },
    ADD_JOB(state, job) {
      job.job_id = (+job.job_id)||null;
      state.jobs.push(job);
    },
    UPDATE_JOB(state, {job, jobIndex}) {
      job.job_id = (+job.job_id)||null;
      Vue.set(state.jobs, jobIndex, job);
    },
    REMOVE_JOB(state, jobIndex) {
      Vue.delete(state.jobs, jobIndex);
    },
    PRINTER_WEBSOCKET_CONNECT(state) {
      state.printersWebsocketConnect = true;
    },
    PRINTERS_LOADED(state) {
      state.printersLoaded = true;
    },
    SET_PRINT_SETTINGS(state, printSettings) {
      state.printSettings = printSettings;
    },
    SET_DISCONNECTED_PRINTERS(state, disconnectedPrinters) {
      state.dPrinters = disconnectedPrinters;
    },
    ADD_DISCONNECTED_PRINTER(state, dPrinter) {
      state.dPrinters.push(dPrinter);
    },
    DELETE_DISCONNECTED_PRINTER(state, dPrinterIndex) {
      Vue.delete(state.dPrinters, dPrinterIndex);
    },
    DISCONNECTED_PRINTER_WEBSOCKET_CONNECT(state) {
      state.dPrintersWebsocketConnect = true;
    }
  },
  actions: {
    async fetchPrintersPageData(context) {
      const {data} = await Vue.axios.post('/a/print/printers_page');
      updatePrintersAndJobs(context, data);
      context.commit('PRINTERS_LOADED');
      triggerPendingEvents(context);
      context.dispatch('checkAllHostsCliVersion');
    },
    async fetchPrinterData(context, printerId) {
      const {data} = await Vue.axios.post('/a/print/refresh_printer_data', {'printer_id': printerId, 'format_job_date': 'no'});
      updatePrintersAndJobs(context, data);
      triggerPendingEvents(context);
      if (data.message.printers.length) {
        context.dispatch('checkOneHostCliVersion', data.message.printers[0].host_id);
      }
    },
    async refreshJobData(context, {printerId, jobId}) {
      const {data} = await Vue.axios.post('/a/print/one_job_refresh', {'printer_id': printerId, 'job_id': jobId});
      updatePrintersAndJobs(context, data);
      triggerPendingEvents(context);
    },
    updateJobsData(context, jobs) {
      updatePrintersAndJobs(context, {result: true, message: {jobs}});
      triggerPendingEvents(context);
    },
    async checkAllHostsCliVersion(context) {
      let versions = [];
      for (let i in context.state.hosts) {
        const host = context.state.hosts[i];
        if (host.cli_ver && host.host_num.indexOf('RND_') !== 0 && versions.indexOf(host.cli_ver) < 0) {
          versions.push(host.cli_ver);
        }
      }
      const {data} = await Vue.axios.post('/a/print/check_version', {'cli_ver': versions});
      if (!data.result) {
        return;
      }
      latestCliVersion = data.message.cur_ver;
      const latestU3Version = data.message.cur_ver_u3;
      for (let hostIndex in context.state.hosts) {
        if (context.state.hosts[hostIndex].host_num.indexOf('RND_') === 0) {
          continue;
        }
        const ver = context.state.hosts[hostIndex].cli_ver;
        if (!ver || data.message.results[ver]) {
          const host = Object.assign(
            {},
            context.state.hosts[hostIndex],
            {"last_cli_ver" : ver === 'u3' ? latestU3Version : latestCliVersion});
          context.commit('UPDATE_HOST', {host, hostIndex});
        }
      }
    },
    async checkOneHostCliVersion(context, hostId) {
      const hostIndex = context.getters.getHostIndex(hostId);
      if (hostIndex < 0) {
        return;
      }
      let lastCliVer = latestCliVersion;
      if (context.state.hosts[hostIndex].cli_ver) {
        const cliVersion = context.state.hosts[hostIndex].cli_ver;
        //Search for host in hosts list with the same cli version
        for (let i in context.state.hosts) {
          if (context.state.hosts[i].host_id != hostId && context.state.hosts[i].cli_ver == cliVersion) {
            if (context.state.hosts[i].last_cli_ver) {
              const host = Object.assign(
                {},
                context.state.hosts[hostIndex],
                {"last_cli_ver": context.state.hosts[i].last_cli_ver});
              context.commit('UPDATE_HOST', {host, hostIndex});
              return;
            }
          }
        }
        //Send host version to backend to check for outdate
        const {data} = await Vue.axios.post('/a/print/check_version', {'cli_ver': cliVersion});
        if (!data.result) {
          return;
        }
        if (data.message.results && data.message.results[cliVersion]) {
          latestCliVersion = data.message.cur_ver;
          lastCliVer = data.message.results[cliVersion] === 'u3' ? data.message.cur_ver_u3 : latestCliVersion
        }
      }
      const host = Object.assign(
        {},
        context.state.hosts[hostIndex],
        {"last_cli_ver" : lastCliVer});
      context.commit('UPDATE_HOST', {host, hostIndex});
    },
    startListenPrinterEvents(context) {
      if (!context.getters.isPrinterWebsocketConnected) {
        const printerWsConnection = new WebsocketConnection('printer');
        printerWsConnection.connect((socket) => {
          //Register websocket event handlers only if connected first time (websocket connection can be reconnected)
          if (!context.getters.isPrinterWebsocketConnected) {
            context.commit('PRINTER_WEBSOCKET_CONNECT');
            //Register event handlers
            for (let i in websocketPrinterEvents) {
              const eventName = websocketPrinterEvents[i];
              socket.on(eventName, (event) => {
                handlePrinterWebsocketEvent(context, eventName, event);
              });
            }
          }
          context.dispatch('fetchPrintersPageData');
        })
      }
      if (!context.getters.isDisconnectedPrinterWebsocketConnected) {
        const dPrinterWsConnection = new WebsocketConnection('dprinter');
        dPrinterWsConnection.connect((socket) => {
          //Register websocket event handlers only if connected first time (websocket connection can be reconnected)
          if (!context.getters.isDisconnectedPrinterWebsocketConnected) {
            context.commit('DISCONNECTED_PRINTER_WEBSOCKET_CONNECT');
            //Register event handlers
            for (let i in websocketDIsconnectedPrinterEvents) {
              const eventName = websocketDIsconnectedPrinterEvents[i];
              socket.on(eventName, (event) => {
                handleDisconnectedPrinterWebsocketEvent(context, eventName, event);
              });
            }
          }
        })
      }
    },
    startJob(context, {printerId, jobId}) {
      return Vue.axios.post('/a/print/start', {'printer_id': printerId, 'job_id': jobId});
    },
    printingPause(context, printerId) {
      return Vue.axios.post('/a/print/pause', {'printer_id': printerId});
    },
    printingResume(context, printerId) {
      return Vue.axios.post('/a/print/unpause', {'printer_id': printerId});
    },
    printingVirtualFinish(context, printerId) {
      return Vue.axios.post('/virtual/finish_print', {'printer_id': printerId});
    },
    printingVirtualError(context, printerId) {
      return Vue.axios.post('/virtual/failed_print', {'printer_id': printerId});
    },
    getPrinterSharing(context, printerId) {
      return Vue.axios.post('/ajax/get_share_printer_data', {'printer_id': printerId});
    },
    sharePrinter(context, {printerId, email, role, limit, checkUser}) {
      return Vue.axios.post('/ajax/share_printer', {
        printer_id: printerId,
        user_email: email,
        number_of_prints: limit,
        role_id: role,
        not_existed: 1,
        check_user: checkUser ? 1 : 0
      });
    },
    unsharePrinter(context, shareId) {
      return Vue.axios.post('/ajax/unshare_printer', {'share_id': shareId});
    },
    getPrinterOwner(context, printerId) {
      return Vue.axios.post('/a/print/get_printer_owner', {'printer_id': printerId});
    },
    updatePrinterSettings(context, data) {
      return Vue.axios.post('/a/print/update_printer_info', data);
    },
    resetCamera(context, printerId) {
      return Vue.axios.post('/a/print/camera_reset', {'printer_id': printerId});
    },
    updateCameraType(context, {printerId, cameraType}) {
      return Vue.axios.post('/a/print/update_camera_type', {'printer_id': printerId, 'camera_type': cameraType});
    },
    getCameraListToken(context, printerId) {
      let params = {'printer_id': printerId};
      // if (allCamerasInfo) {
      //   params['get_all_cameras_info'] = 1;
      // }
      return Vue.axios.post('/a/print/get_camera_list_token', params);
    },
    setCameraRotate(context, {printerId, rotate}) {
      return Vue.axios.post('/a/print/set_camera_rotate', {'printer_id': printerId, rotate: rotate ? 1 : 0});
    },
    restorePrinter(context, printerId) {
      return Vue.axios.post('/a/print/restore_printer', {'printer_id': printerId});
    },
    deletePrinter(context, printerId) {
      return Vue.axios.post('/a/print/delete_printer', {'printer_id': printerId, 'delete': 1});
    },
    addNewPrinter(context, printerTypes) {
      let request = {};
      for (let i in printerTypes) {
        const key = 'printers[' + i + '][type_id]';
        request[key] = printerTypes[i];
      }
      return Vue.axios.post('/a/DisconnectedPrinters/add', request);
    },
    getJobSlicingSettings(context, jobId) {
      return Vue.axios.post('/a/job/get_job_slicer_settings', {'job_id': jobId});
    },
    getJobLogs(context, jobId) {
      return Vue.axios.post('/a/print/get_log', {'job_id': jobId, 'duration': 1});
    },
    getJobTransactions(context, jobId) {
      return Vue.axios.post('/a/job/get_transactions', {'id': jobId});
    },
    createJobTransaction(context, {jobId, amount, expectedCost, desc}) {
      return Vue.axios.post('/a/job/new_transaction', {'id': jobId, amount: amount, expected_cost: expectedCost, desc: desc});
    },
    getJobNotes(context, jobId) {
      return Vue.axios.post('/a/job/get_job_notes', {'job_id': jobId});
    },
    addJobNote(context, {jobId, note, isFeedback}) {
      return Vue.axios.post('/a/job/add_job_note', {
        'job_id': jobId,
        'note': note,
        'feedback': isFeedback
      });
    },
    clearBuildTray(context, {printerId, isClear}) {
      return Vue.axios.post('/a/print/clear_build_tray', {'printer_id': printerId, 'is_clear': isClear});
    },
    copyJobToPrinter(context, {printerId, jobId, sharePrinter, originalPrinterOwner, onlyQueue}) {
      return Vue.axios.post('/a/print/copy_job_to_printer', {
        'printer_id': printerId,
        'job_id': jobId,
        'share_printer': sharePrinter,
        'original_job_owner': originalPrinterOwner,
        'only_queue': onlyQueue,
        'questions': '[]'
      });
    },
    moveJobToPrinter(context, {printerId, jobId, sharePrinter}) {
      return Vue.axios.post('/a/print/move_job_to_another_printer', {
        'printer_id': printerId,
        'job_id': jobId,
        'share_printer': sharePrinter,
        'only_queue': true
      });
    },
    setHostName(context, {hostId, name}) {
      return Vue.axios.post('/a/print/set_host_name', {'host_id': hostId, 'name': name});
    },
    setHostColor(context, {hostId, color}) {
      return Vue.axios.post('/a/print/set_host_color', {'host_id': hostId, 'color': color});
    },
    getUserHosts() {
      return Vue.axios.post('/virtual/get_user_hosts');
    },
    addPrinterByRegistrationCode(context, code) {
      return Vue.axios.post('/a/print/add_printer_by_registration_code', {'registration_code': code});
    },
    deleteDisconnectedPrinter(context, disconnectedPrinterId) {
      return Vue.axios.post('/a/DisconnectedPrinters/delete', {'id': disconnectedPrinterId});
    },
    addIndustrialPrinter(context, {printerTypeId, hostId, printerName, disconnectedPrinterId}) {
      let requestData = {
        type_id: printerTypeId,
        host_id: hostId,
        name: printerName,
      };
      if (disconnectedPrinterId) {
        requestData.disconnected_printer_id = disconnectedPrinterId;
      }
      return Vue.axios.post('/virtual/add_printer', requestData);
    },
    connectToWorkgroup(context, code) {
      return Vue.axios.post('/workgroup/add_user_to_workgroup_by_password/', {'password': code});
    },
    fetchJobHistory(context, {isOrganization, startDate, endDate, search, page}) {
      let request = {page: page ? page : 0, 'ptype': isOrganization ? 'org' : 'my'};
      if (startDate) {
        request.from = startDate;
      }
      if (endDate) {
        request.to = endDate;
      }
      if (search && search.trim()) {
        request.search = search.toLowerCase();
      }
      return Vue.axios.post('/dashboard/fetch_history', request);
    },
    fetchJobHistoryAutocomplete(context, {isOrganization, search, startDate, endDate}) {
      let request = {search: search, 'ptype': isOrganization ? 'org' : 'my'};
      if (startDate) {
        request.from = startDate;
      }
      if (endDate) {
        request.to = endDate;
      }
      return Vue.axios.post('/dashboard/history_autocomplete', request);
    },
    fetchJobHistoryStatistic(context, {isOrganization, search, startDate, endDate}) {
      let request = {'ptype': isOrganization ? 'org' : 'my'};
      if (startDate) {
        request.from = startDate;
      }
      if (endDate) {
        request.to = endDate;
      }
      if (search) {
        request.search = search;
      }
      return Vue.axios.post('/dashboard/history_statistic', request);
    },
    fetchJobData(context, jobId) {
      return Vue.axios.post('/a/print/get_job_data', {'job_id': jobId});
    },
    printFile(context, {fileId, printerId, onlyQueue}) {
      return Vue.axios.post('/a/print/print_file', {'file_id': fileId, 'printer_id': printerId, 'only_queue': onlyQueue, 'notes': '', 'questions': []});
    },
    cancelJob(context, {printerId, jobId}) {
      return Vue.axios.post('/a/print/cancel', {'printer_id': printerId, 'job_id': jobId});
    },
    setJobCancelReason(context, data) {
      return Vue.axios.post('/a/print/set_cancel_reasons', data);
    },
    startNextJob(context, printerId) {
      return Vue.axios.post('/a/print/start_next_job', {'printer_id': printerId});
    },
    addNewImprintaPrinter(context, serialNumber) {
      return Vue.axios.post('/a/imprinta/register_printer', {serialnumber: serialNumber});
    },
    fetchPrinterLogs(context, {printerId, duration}) {
      return Vue.axios.post('/a/print/get_printer_log', {'printer_id': printerId, 'duration': duration});
    }
  },
  getters: {
    isPrinterWebsocketConnected: state => {
      return state.printersWebsocketConnect;
    },
    isPrintersLoaded: state => {
      return state.printersLoaded;
    },
    getPrintSettings: state => {
      return state.printSettings;
    },
    getHostIndex: state => id => {
      return state.hosts.findIndex(host => host.host_id == id);
    },
    getPrinterIndex: state => id => {
      return state.printers.findIndex(printer => printer.printer_id == id);
    },
    getJobIndex: state => id => {
      return state.jobs.findIndex(job => job.job_id == id);
    },
    getJobById: state => id => {
      return state.jobs.find(job => job.job_id == id);
    },
    getPrintingStates: state => {
      return state.printingStates
    },
    isPrintingState: state => printerState => {
      return state.printingStates.indexOf(printerState) >= 0;
    },
    getHosts: state => {
      return state.hosts;
    },
    hostsCount: state => {
      return state.hosts.length
    },
    getPrinters: state => {
      return state.printers;
    },
    getActivePrinters: state => {
      return state.printers.filter(printer => printer.active === 't');
    },
    geIdlePrintersWithActiveCamera: state => {
      return state.printers.filter(printer => printer.active === 't' && printer.state !== 'offline' && printer.camera_type && printer.camera_type !== 'Disable camera' && printer.webcam_id > 0);
    },
    getInactivePrinters: state => {
      return state.printers.filter(printer => printer.active !== 't');
    },
    getActivePrintersByHost: state => hostId => {
      return state.printers.filter(printer => printer.active === 't' && printer.host_id == hostId);
    },
    getJobs: state => {
      return state.jobs;
    },
    getJobsByPrinter: state => printerId => {
      return state.jobs.filter(job => job.printer_id == printerId);
    },
    isDisconnectedPrinterWebsocketConnected: state => {
      return state.dPrintersWebsocketConnect;
    },
    getDisconnectedPrinters: state => {
      return state.dPrinters;
    },
    getDisconnectedPrinterIndex: state => dPrinterId => {
      return state.dPrinters.findIndex(dPrinter => dPrinterId == dPrinter.id);
    },
    isPrinterHasNotFinishedJobs: state => printerId => {
      for (let i in state.jobs) {
        if (state.jobs[i].printer_id != printerId) {
          continue;
        }
        const statusId = state.jobs[i].status_id;
        if (state.jobs[i].printing_duration > 0 && (statusId == 21 || statusId == 35 || statusId == 11)) {
          return true;
        }
      }

      return false;
    },
    getPrinterBySerialNumber: state => serialNumber => {
      for (let i in state.printers) {
        if (state.printers[i].active === 't' &&
          state.printers[i].srn &&
          state.printers[i].srn.trim() === serialNumber.trim()) {
          return state.printers[i];
        }
      }

      return undefined;
    }
  }
}
